<template>
  <div class="row bg-blue actions">
    <div class="col-auto">
      <button type="button" class="btn btn-size-s" @click="onDisplayCustomer">
        {{L10n('display-customer-po-followup')}}
      </button>
    </div>
    <div class="col-auto">
      <logo-button
        class="btn-mobile-full mt-3"
        :get-pdf-content="getPdfContent"
        @click="onSendExchangeAgreement"
      >
        {{L10n('send-email-exchange-agreement')}}
      </logo-button>
    </div>
    <div class="col-lg-auto">
      <logo-button
        class="btn-mobile-full mt-3"
        :get-pdf-content="getPdfContent"
        @click="onPrintExchangeAgreement"
      >
        {{L10n('print-exchange-agreement')}}
      </logo-button>
    </div>
  </div>
</template>

<script>
import { ServicePdf } from '@/services/pdf-generators'

export default {
  name: 'UserActions',
  props: {
    rfq3ID: { type: String, required: true }
  },
  components: {
    'logo-button': () => import(/* webpackChunkName: 'UI' */ '@/components/Shared/LogoButton')
  },
  methods: {
    onDisplayCustomer () {
      this.$emit('onDisplayCustomer')
    },
    onSendExchangeAgreement (logoKey) {
      this.$emit('onSendExchangeAgreement', logoKey)
    },
    onPrintExchangeAgreement (logoKey) {
      this.$emit('onPrintExchangeAgreement', logoKey)
    },
    getPdfContent () {
      return ServicePdf.generateExchangeAgreementContent({ id: this.rfq3ID, translate: this.L10n })
    }
  }
}
</script>

<style lang="stylus" scoped>
  .btn, .logo-btn{
    margin 1rem 0
  }
  .actions{
    padding: 1.5rem;
    margin: -2rem -2.5rem 0 -2.5rem;
  }
</style>
